<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container>
        <v-row align="end" class="justify-space-between">
          <v-col cols="12" md="6">
            <div class="page-title">
              <a href="/doacoes/minhas"
                ><v-icon class="mr-3">fal fa-arrow-left</v-icon></a
              >
              <h1>Configurações</h1>
            </div>
          </v-col>
          <v-col class="text-right" cols="12" md="6">
            <h4 class="purple--text secondary--text">
              {{ council.entityViewModel.name }}
            </h4>
          </v-col>
        </v-row>
      </v-container>

      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" lg="6">
              <!-- Card-1 -->
              <v-card class="fill-height" elevation="8">
                <!--card title-->
                <v-card-title class="pb-0">
                  <v-container class="d-flex align-center">
                    <span class="list-labels">Esquema de cores</span>
                  </v-container>
                </v-card-title>

                <!--card content-->
                <v-card-text>
                  <v-container>
                    <v-row>
                      <!-- colorpickers ###################################### -->
                      <v-col cols="auto">
                        <div>
                          <v-text-field
                            value="Cor Primária"
                            hide-details
                            class="ma-0 pa-0 elevation-4"
                            outlined
                            solo
                            flat
                            readonly
                          >
                            <template v-slot:append>
                              <v-menu
                                top
                                nudge-bottom="99"
                                nudge-left="16"
                                :close-on-content-click="false"
                              >
                                <template v-slot:activator="{ on }">
                                  <div :style="swatchStyle" v-on="on" />
                                </template>
                                <v-card>
                                  <v-card-text class="pa-0">
                                    <v-color-picker
                                      v-model="councilConfig.primaryColor"
                                      flat
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="auto">
                        <div>
                          <v-text-field
                            value="Cor Destaque"
                            hide-details
                            class="ma-0 pa-0 elevation-4"
                            outlined
                            solo
                            flat
                            readonly
                          >
                            <template v-slot:append>
                              <v-menu
                                top
                                nudge-bottom="99"
                                nudge-left="16"
                                :close-on-content-click="false"
                              >
                                <template v-slot:activator="{ on }">
                                  <div :style="swatchStyle1" v-on="on" />
                                </template>
                                <v-card>
                                  <v-card-text class="pa-0">
                                    <v-color-picker
                                      v-model="councilConfig.secondaryColor"
                                      flat
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" lg="6">
              <!-- Card-2 -->
              <v-card class="fill-height" elevation="8">
                <!--card title-->
                <v-card-title class="pb-0">
                  <v-container
                    class="d-flex align-center justify-space-between"
                  >
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="list-labels">Redirecionamento</span>
                      </v-col>
                      <v-col cols="12" sm="6" class="text-right">
                        <span class="span-skin clickable">
                          <v-icon class="mr-4" color="#668DF6">
                            fal fa-globe
                          </v-icon>
                          <a
                            class="blue--text"
                            target="_blank"
                            :href="councilUrl"
                          >
                            {{ councilUrl }}
                          </a>
                        </span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>

                <!--card content-->
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          background-color="#fff"
                          outlined
                          label="URL"
                          hide-details="auto"
                          v-model="councilConfig.siteRedirect"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <!-- logotipo ###################################### -->
        <v-container>
          <!-- Card-3 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Logotipos</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col cols="12" sm="6">
                    <div class="pb-4">
                      Logotipo para fundo <b class="blue--text">Claro</b>
                    </div>
                    <v-avatar
                      size="220"
                      class="style-avatar flex-column justify-center"
                      tile
                    >
                      <div>
                        <v-icon
                          @click="onPickFile('lightLogoImageFileInput')"
                          size="35"
                          class="clickable flex-grow-0"
                          color="var(--gray-light)"
                          >fas fa-image</v-icon
                        >
                        <img
                          :src="selectedLightLogoImageFileContent"
                          height="150"
                          @click="onPickFile('lightLogoImageFileInput')"
                        />
                        <input
                          type="file"
                          style="display: none"
                          ref="lightLogoImageFileInput"
                          accept="image/*"
                          @change="onFilePicked($event, 'lightLogoImage')"
                          required
                        />
                        <h6 class="tiny-label mt-2">LOGOTIPO</h6>
                      </div>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="pb-4">
                      Logotipo para fundo <b class="blue--text">Escuro</b>
                    </div>
                    <v-avatar
                      size="220"
                      class="style-avatar-dark flex-column justify-center"
                      tile
                    >
                      <div>
                        <v-icon
                          @click="onPickFile('darkLogoImageFileInput')"
                          size="35"
                          class="clickable flex-grow-0"
                          color="var(--gray-light)"
                          >fas fa-image</v-icon
                        >
                        <img
                          :src="selectedDarkLogoImageFileContent"
                          height="150"
                          @click="onPickFile('darkLogoImageFileInput')"
                        />
                        <input
                          type="file"
                          style="display: none"
                          ref="darkLogoImageFileInput"
                          accept="image/*"
                          @change="onFilePicked($event, 'darkLogoImage')"
                          required
                        />
                        <h6 class="tiny-label mt-2">LOGOTIPO</h6>
                      </div>
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- imagem de fundo - login ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Imagem de fundo - login</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col cols="12">
                    <v-layout>
                      <div
                        class="img-fundo"
                        :style="{
                          background: `linear-gradient(-45deg, ${councilConfig.primaryColor}, ${councilConfig.secondaryColor})`
                        }"
                      >
                        <div class="image-login">
                          <img
                            :src="selectedBackgroundImageContent"
                            ref="backgroundImageImgElement"
                          />
                        </div>
                        <div class="p-relative">
                          <input
                            class="upload-login"
                            type="file"
                            accept="image/*"
                            @change="onFilePicked($event, 'backgroundImage')"
                          />
                          <v-icon
                            class="clickable upload-btn"
                            size="30"
                            color="#FFFFFF"
                          >
                            fas fa-cloud-upload
                          </v-icon>
                        </div>
                        <div
                          class="img-fundo-status"
                          v-show="isBackgroundImageSelected"
                        >
                          <v-icon class="mr-2" size="16">fas fa-image</v-icon>
                          <span
                            >Imagem atual: {{ backgroundImageHeight }}x{{
                              backgroundImageWidth
                            }}px [450kb]</span
                          >
                          <!-- <v-icon class="ml-4" color="var(--blue)" size="16">
                            fas fa-external-link-square
                          </v-icon> -->
                        </div>
                      </div>
                    </v-layout>
                  </v-col>
                  <v-col cols="12">
                    <v-layout class="justify-space-between">
                      <div class="top-bloc">
                        <div
                          class="degrad-bloco"
                          :style="{
                            backgroundColor: `${councilConfig.secondaryColor}`
                          }"
                        ></div>
                      </div>
                      <div class="bottom-bloc">
                        <div
                          class="degrad-bloco"
                          :style="{
                            backgroundColor: `${councilConfig.primaryColor}`
                          }"
                        ></div>
                      </div>
                    </v-layout>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <!-- tamanho imagem de fundo ###################################### -->
                  <v-col cols="12">
                    <v-layout class="flex-column">
                      <div class="img-tam">
                        Tamanho mínimo:<span class="ml-10">1680x900px</span>
                      </div>
                      <div class="img-tam">
                        Tamanho recomendado:<span class="ml-10"
                          >2800x1500px</span
                        >
                      </div>
                      <div class="img-tam">
                        Peso máximo da imagem:<span class="ml-10">480kb</span>
                      </div>
                    </v-layout>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- E-mails de Recebimento ###################################### -->
        <v-container>
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex justify-space-between">
                <span class="list-labels"
                  >E-mails de recebimento fale conosco</span
                >
                <v-btn
                  fab
                  depressed
                  small
                  outlined
                  color="var(--gray-light)"
                  @click="addContactUsEmail()"
                >
                  <v-icon size="14" color="var(--gray)">fal fa-plus</v-icon>
                </v-btn>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="pb-0">
              <v-container class="grid-list-sm pt-0 pb-0">
                <v-row>
                  <v-col cols="12" md="7">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="9" class="pt-0">
                          <v-text-field
                            label="E-mail"
                            outlined
                            hide-details="auto"
                            v-model="newContactUsEmail"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="9"
                          class="pt-0"
                          v-for="(contactUsEmail,
                          index) in councilConfig.contactUsEmailList"
                          :key="index"
                        >
                          <v-text-field
                            label="E-mail"
                            outlined
                            hide-details="auto"
                            class="d-flex align-center justify-center"
                            v-model="contactUsEmail.email"
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                depressed
                                fab
                                color="#FFFFFF"
                                @click="removeContactUsEmail(contactUsEmail)"
                              >
                                <v-icon color="var(--gray-light)"
                                  >fal fa-trash</v-icon
                                >
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Configurações para compartilhamento ###################################### -->
        <v-container class="pb-0">
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels"
                  >Configurações para compartilhamento</span
                >
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container class="grid-list-sm d-flex pt-0 pb-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Título"
                            outlined
                            counter="50"
                            v-model="councilConfig.titleShare"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            label="Descrição"
                            auto-grow
                            outlined
                            rows="8"
                            counter="160"
                            v-model="councilConfig.descriptionShare"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <div class="share-wpp elevation-2">
                      <div class="share-favicon">
                        <img
                          :src="selectedShareImageFileContent"
                          height="150"
                          @click="onPickFile('shareImageFileInput')"
                        />
                        <input
                          type="file"
                          style="display: none"
                          ref="shareImageFileInput"
                          accept="image/*"
                          @change="onFilePicked($event, 'shareImage')"
                          required
                        />
                        <v-icon
                          v-show="selectedShareImageFileContent == ''"
                          @click="onPickFile('shareImageFileInput')"
                          size="30"
                          class="clickable op-5"
                          color="#9DA0B5"
                          >fas fa-cloud-upload</v-icon
                        >
                      </div>
                      <div class="d-flex flex-column">
                        <span class="preview-title mt-5 ml-5"
                          ><b>{{ councilConfig.titleShare }}</b></span
                        >
                        <span class="preview-comp mt-1 ml-5" color="#828282">{{
                          councilConfig.descriptionShare
                        }}</span>
                        <span class="preview-comp mt-1 ml-5" color="#828282">{{
                          councilConfig.siteRedirect
                        }}</span>
                      </div>
                    </div>
                    <div class="mt-4">
                      <span class="preview-comp" color="#828282"
                        >Preview compartilhamento: Whatsapp</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Favicon ###################################### -->
        <v-container>
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Favicon</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container class="grid-list-sm pt-0">
                <v-row>
                  <v-col cols="12" md="7">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="10">
                          <div>
                            <span class="favicon-span"
                              >O tamanho da imagem de favicon deve ser de até
                              200kb e será exibido como no exemplo abaixo.</span
                            >
                          </div>
                          <div>
                            <span class="preview-favicon"
                              >Preview fav-icon: Google Chrome</span
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12">
                          <v-layout id="preview-favicon" wrap>
                            <!-- <div class="favicon-upload mt-4 flex-shrink-0 sm6">
                              <v-icon
                                class="clickable op-5"
                                size="30"
                                color="#9DA0B5"
                                v-model="councilConfig.iconShare"
                                >fas fa-book-open</v-icon
                              >
                            </div> -->
                            <div class="favicon-upload mt-4 flex-shrink-0 sm6">
                              <img
                                :src="selectedFaviconImageFileContent"
                                height="150"
                                @click="onPickFile('faviconImageFileInput')"
                              />
                              <input
                                type="file"
                                style="display: none"
                                ref="faviconImageFileInput"
                                accept="image/*"
                                @change="onFilePicked($event, 'faviconImage')"
                                required
                              />
                              <v-icon
                                v-show="selectedFaviconImageFileContent == ''"
                                @click="onPickFile('faviconImageFileInput')"
                                size="30"
                                class="clickable op-5"
                                color="#9DA0B5"
                                >fas fa-book-open</v-icon
                              >
                            </div>
                            <div class="url-light mt-2 sm6">
                              <v-img
                                class="img-light"
                                src="/images/browser_claro.png"
                              >
                                <div class="title-share-light">
                                  {{ councilConfig.titleShare }}
                                </div>
                                <div class="url-share-light">
                                  {{ councilConfig.siteRedirect }}
                                </div>
                                <div
                                  class="favicon-light"
                                  :style="faviconStyle"
                                ></div>
                              </v-img>
                              <v-img
                                class="img-light"
                                src="/images/browser_escuro.png"
                              >
                                <div class="title-share-dark">
                                  {{ councilConfig.titleShare }}
                                </div>
                                <div class="url-share-dark">
                                  {{ councilConfig.siteRedirect }}
                                </div>
                                <div
                                  class="favicon-dark"
                                  :style="faviconStyle"
                                ></div>
                              </v-img>
                            </div>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Google Analytics ###################################### -->
        <v-container mb-8>
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Google Analytics e Tag Manager</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="mb-container pb-0">
              <v-container class="grid-list-sm pt-0">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Google Analytics - ID"
                      outlined
                      hide-details="auto"
                      v-model="councilConfig.googleAnalyticsID"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Google Tag Manager - ID"
                      outlined
                      hide-details="auto"
                      v-model="councilConfig.googleTagManagerID"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- buttons float ###################################### -->
        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn
                color="var(--gray-light)"
                rounded
                large
                depressed
                class="px-12 mr-1 white--text footer-border-left"
                @click="gotoCouncilManagement"
                >Voltar</v-btn
              >
              <v-btn
                color="secondary"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-right"
                @click="save"
                >Salvar</v-btn
              >
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import EntityService from "@/scripts/services/entity.service";
import Routes from "@/router/names.js";
import CommonHelper from "@/scripts/helpers/common.helper";
export default {
  name: "Configuration",
  components: {
    NavBar
  },
  data: () => ({
    entityService: new EntityService(),
    council: {
      entityViewModel: {
        name: ""
      }
    },
    councilConfig: {
      councilId: 0,
      primaryColor: "#45588D",
      secondaryColor: "#668DF6",
      siteRedirect: "",
      titleShare: "",
      descriptionShare: "",
      iconShare: "",
      contactUsEmailList: [],
      googleTagManagerID: "",
      googleAnalyticsID: ""
    },
    newContactUsEmail: "",

    selectedBackgroundImage: null,
    selectedBackgroundImageContent: "",

    selectedLightLogoImage: null,
    selectedLightLogoImageFileContent: "",

    selectedDarkLogoImage: null,
    selectedDarkLogoImageFileContent: "",

    selectedShareImage: null,
    selectedShareImageFileContent: "",

    selectedFaviconImage: null,
    selectedFaviconImageFileContent: ""
  }),
  computed: {
    ...mapGetters(["selectedCouncil"]),
    swatchStyle() {
      return {
        backgroundColor: this.councilConfig.primaryColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "25px",
        transition: "border-radius 200ms ease-in-out"
      };
    },
    swatchStyle1() {
      return {
        backgroundColor: this.councilConfig.secondaryColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "25px",
        transition: "border-radius 200ms ease-in-out"
      };
    },
    councilUrl() {
      return `${window.location.protocol}//${window.location.host}/conselho/${this.council.id}`;
    },
    isBackgroundImageSelected() {
      return !!this.selectedBackgroundImage;
    },
    backgroundImageHeight() {
      if (this.isBackgroundImageSelected) {
        return this.$refs.backgroundImageImgElement.naturalHeight;
      }
      return 0;
    },
    backgroundImageWidth() {
      if (this.isBackgroundImageSelected)
        return this.$refs.backgroundImageImgElement.naturalWidth;
      return 0;
    },
    faviconStyle() {
      return `background-image: url("${this.selectedFaviconImageFileContent}")`;
    }
  },
  created() {
    if (
      this.$route.params.councilId &&
      this.selectedCouncil &&
      this.selectedCouncil.id == this.$route.params.councilId
    ) {
      this.setCouncil(this.selectedCouncil);
    } else if (this.$route.params.councilId) {
      this.entityService
        .getCouncilById(this.$route.params.councilId)
        .then(this.getCouncilByIdCallBack);
    } else {
      this.setSelectedCouncil(null);
      this.gotoCouncilManagement();
    }
  },
  methods: {
    ...mapActions(["setSelectedCouncil"]),
    setCouncil(c) {
      this.council = { ...c };
      this.council.entityViewModel.addressViewModel = {
        ...c.entityViewModel.addressViewModel
      };
      this.entityService
        .getCouncilConfig(this.council.id)
        .then(this.getCouncilConfigCallback);
    },
    save() {
      this.addContactUsEmail();
      this.councilConfig.councilId = this.council.id;
      this.entityService
        .saveCouncilConfig(
          this.councilConfig,
          this.selectedBackgroundImage,
          this.selectedLightLogoImage,
          this.selectedDarkLogoImage,
          this.selectedShareImage,
          this.selectedFaviconImage
        )
        .then(this.saveCouncilConfigCallback);
    },
    getCouncilByIdCallBack(data) {
      if (data == null) this.gotoCouncilManagement();
      this.setCouncil(data);
    },
    saveCouncilConfigCallback() {
      this.gotoCouncilManagement();
    },
    getCouncilConfigCallback(data) {
      this.councilConfig = data;
      if (data.faviconImage) {
        if (data.faviconImage.url)
          this.selectedFaviconImageFileContent = data.faviconImage.url;
        else
          this.selectedFaviconImageFileContent = `data:${data.faviconImage.contentType};base64, ${data.faviconImage.content}`;
      }

      if (data.backgroundImage) {
        if (data.backgroundImage.url)
          this.selectedBackgroundImageContent = data.backgroundImage.url;
        else
          this.selectedBackgroundImageContent = `data:${data.backgroundImage.contentType};base64, ${data.backgroundImage.content}`;
      }

      if (data.darkLogo) {
        if (data.darkLogo.url)
          this.selectedDarkLogoImageFileContent = data.darkLogo.url;
        else
          this.selectedDarkLogoImageFileContent = `data:${data.darkLogo.contentType};base64, ${data.darkLogo.content}`;
      }

      if (data.lighLogo) {
        if (data.lighLogo.url)
          this.selectedLightLogoImageFileContent = data.lighLogo.url;
        else
          this.selectedLightLogoImageFileContent = `data:${data.lighLogo.contentType};base64, ${data.lighLogo.content}`;
      }

      if (data.shareImage) {
        if (data.shareImage.url)
          this.selectedShareImageFileContent = data.shareImage.url;
        else
          this.selectedShareImageFileContent = `data:${data.shareImage.contentType};base64, ${data.shareImage.content}`;
      }
    },
    onPickFile(input) {
      if (!this.saving) this.$refs[input].click();
    },
    onFilePicked(event, identifier) {
      const files = event.target.files;
      if (identifier === "backgroundImage")
        this.selectedBackgroundImage = files[0];
      else if (identifier === "lightLogoImage")
        this.selectedLightLogoImage = files[0];
      else if (identifier === "darkLogoImage")
        this.selectedDarkLogoImage = files[0];
      else if (identifier === "shareImage") this.selectedShareImage = files[0];
      else if (identifier === "faviconImage")
        this.selectedFaviconImage = files[0];

      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        return alert("Por favor adicione um arquivo válido");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        if (identifier === "backgroundImage")
          this.selectedBackgroundImageContent = fileReader.result;
        else if (identifier === "lightLogoImage")
          this.selectedLightLogoImageFileContent = fileReader.result;
        else if (identifier === "darkLogoImage")
          this.selectedDarkLogoImageFileContent = fileReader.result;
        else if (identifier === "shareImage")
          this.selectedShareImageFileContent = fileReader.result;
        else if (identifier === "faviconImage")
          this.selectedFaviconImageFileContent = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    },
    addContactUsEmail() {
      this.newContactUsEmail = this.newContactUsEmail.trim();
      if (
        !!this.newContactUsEmail &&
        CommonHelper.validateEmail(this.newContactUsEmail)
      ) {
        this.councilConfig.contactUsEmailList.push({
          email: this.newContactUsEmail
        });
        this.newContactUsEmail = "";
      }
    },
    removeContactUsEmail(contactUsEmail) {
      this.councilConfig.contactUsEmailList.splice(
        this.councilConfig.contactUsEmailList.indexOf(contactUsEmail),
        1
      );
    },
    gotoCouncilManagement() {
      this.$router.push({ name: Routes.app.CouncilManagement });
    }
  }
};
</script>